module.exports = __webpack_public_path__ + "static/media/mode-536.312d8a85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-536.svg
// module id = 1072
// module chunks = 2